import { Diff, stringifyForDiff } from '@gonfalon/launchpad-experimental/Diff';

export function UpdateVariationJsonDiff({ current, updated }: { current: string; updated: string }) {
  const parsedCurrent = stringifyForDiff(JSON.parse(current));
  const parsedUpdated = stringifyForDiff(JSON.parse(updated));
  return <Diff original={parsedCurrent} compare={parsedUpdated} includeSubDiffs isJSON />;
}
